import { Permission } from '@/lib/permissions/v1'
import { rateParamKey, Route } from '@/composables/route'

export const fieldsForTable =
    'uuid,title,name,cost_for_human,price_with_period_and_tax_for_human,created_at,updated_at,company_services_count,articles_count,service_group{uuid,title},children,tariff{uuid,title},cis{uuid,title,url}'
export const fieldsForDetails =
    'uuid,title,name,cost_for_human,price_with_period_and_tax_for_human,created_at,updated_at,company_services_count,articles_count,service_group{uuid,title},tariff{uuid,title},cis{uuid,title,url},datum{uuid,title},price_tax_for_human'

export const fieldsForEdit =
    'uuid,title,name,billing_period_in_months,cost,price,tax_rate_uuid,service_group_uuid,parent_uuid,articles{uuid},tenant_uuid,datum_uuid,tariff_uuid,cis_uuid'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'title',
        direction: 'asc',
    })

    route.view.value = 'tree'
}

export enum RateRoute {
    Index = 'sales.rates.index',
    Create = 'sales.rates.create',
    Edit = 'sales.rates.edit',
    Clone = 'sales.rates.clone',
    Details = 'sales.rates.details',
    Services = 'sales.rates.services',
    Articles = 'sales.rates.articles',
    Logs = 'sales.rates.logs',
}

export default {
    path: 'rates',
    component: () => import('@/views/sales/Index.vue'),
    children: [
        {
            path: '',
            name: RateRoute.Index,
            component: () => import('@/views/sales/rate/Index.vue'),
            meta: {
                label: 'Rates',
                auth: true,
                permission: Permission.RateViewAny,
            },
        },
        {
            path: 'create',
            name: RateRoute.Create,
            component: () => import('@/views/sales/rate/create/Index.vue'),
            meta: {
                label: 'Create Rate',
                auth: true,
                permission: Permission.RateCreate,
            },
        },
        {
            path: `:${rateParamKey}/edit`,
            name: RateRoute.Edit,
            component: () => import('@/views/sales/rate/edit/Index.vue'),
            meta: {
                label: 'Edit Rate',
                auth: true,
                permission: Permission.RateUpdate,
            },
        },
        {
            path: `:${rateParamKey}/clone`,
            name: RateRoute.Clone,
            component: () => import('@/views/sales/rate/create/Index.vue'),
            meta: {
                label: 'Clone Rate',
                auth: true,
                permission: Permission.RateCreate,
            },
        },
        {
            path: `:${rateParamKey}`,
            name: RateRoute.Details,
            component: () => import('@/views/sales/rate/details/Index.vue'),
            meta: {
                label: 'Rate Details',
                auth: true,
                permission: Permission.RateView,
            },
        },
        {
            path: `:${rateParamKey}/services`,
            name: RateRoute.Services,
            component: () => import('@/views/sales/rate/details/Index.vue'),
            meta: {
                label: 'Rate Services',
                auth: true,
                permission: Permission.RateView,
            },
        },
        {
            path: `:${rateParamKey}/articles`,
            name: RateRoute.Articles,
            component: () => import('@/views/sales/rate/details/Index.vue'),
            meta: {
                label: 'Rate Articles',
                auth: true,
                permission: Permission.RateView,
            },
        },
        {
            path: `:${rateParamKey}/logs`,
            name: RateRoute.Logs,
            component: () => import('@/views/sales/rate/details/Index.vue'),
            meta: {
                label: 'Rate Logs',
                auth: true,
                permission: Permission.RateView,
            },
        },
    ],
}
